// extracted by mini-css-extract-plugin
module.exports = {"calendar":"_025a50318d--calendar--37xd9","today":"_025a50318d--today--3A_n4"};